<template>
  <div class="nx-relation-group-card mb-3 nx-primary--lighten-5 empty">
    <v-layout column class="py-4 empty justify-center align-center">
      <v-tooltip bottom v-if="folded">
        <v-btn @click="$emit('unfold')" icon large slot="activator">
          <v-icon large color="primary">visibility_off</v-icon>
        </v-btn>
        <span v-html="$t('message.relation.unfold')"></span>
      </v-tooltip>
      <v-icon v-else-if="showIcon" large color="primary">cancel</v-icon>
      <span class="d-block text mt-1"
            v-html="$tc(folded? 'message.relation.folded': text,
            foldedNumElements, { num: foldedNumElements })">
      </span>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'nx-relation-empty-card',
  props: {
    text: {
      type: String,
      default: 'message.relation.empty',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    folded: {
      type: Boolean,
    },
    foldedNumElements: {
      type: Number,
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

.nx-relation-group-card {
  transition: all .5s;
  will-change: transform;
  .text {
    font-size: 14px;
    font-weight: 400;
    color: $nx-primary--darken-1;
  }
}
</style>
